import { render, staticRenderFns } from "./AnswersWrapper.vue?vue&type=template&id=5c2e0ebe&scoped=true&"
import script from "./AnswersWrapper.vue?vue&type=script&lang=js&"
export * from "./AnswersWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AnswersWrapper.vue?vue&type=style&index=0&id=5c2e0ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e0ebe",
  null
  
)

export default component.exports